import { Trans } from 'react-i18next';

import type { FeedbackPrivacyCopyKey } from '@/constants/review/FeedbackPrivacy';

interface PrivacySentenceProps {
    copyKey: FeedbackPrivacyCopyKey;
    values: Record<string, string | number>;
}

/** One promise of the privacy copy, with the words it stresses in bold. */
export const PrivacySentence = ({ copyKey, values }: PrivacySentenceProps) => (
    <Trans
        i18nKey={copyKey}
        components={{ bold: <b /> }}
        values={values}
    />
);
